import React, { useState } from "react";
import { Container, Divider, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Skeleton } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux';
import { usePrivateDBDetailsQuery, usePrivateDBDeleteMutation } from "services/privatedb";


const PrivateDBView = (props) => {

    const navi = useNavigate();
    const [disableButton, setDisableButton] = useState(false);
    const { id } = useParams();
    const [privateDBDeleteMutation, { isLoading: isUpdating }] = usePrivateDBDeleteMutation();

    const handleCancel = () => {
        navi("/privatedb/list")
    }

    const handleDelete = () => {
        setDisableButton(true)
        privateDBDeleteMutation({ id: id })
            .unwrap()
            .then(result => {
                setDisableButton(false);
                navi("/privatedb/list")
            })
            .catch(err => {
                setDisableButton(false);
                navi("/privatedb/list")
            })

    }

    const { privateDBDetails, privatedbStatus, privatedbLoading, fetching } = usePrivateDBDetailsQuery({ id: id },
        {
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                privateDBDetails: data || {},
                privatedbStatus: status,
                privatedbLoading: isLoading,
                fetching: isFetching
            })
        }
    );


    return (
        <React.Fragment>

            <Container maxWidth={'md'}>
                <Card>
                    {disableButton ? <LinearProgress /> : ''}
                    <Container maxWidth={false} sx={{ paddingTop: "10px" }}>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Case Name</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.case_name || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Tire Brand/Type</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.brand || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">P/LT/Eur-Metric</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.metric || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Section Width</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.section_width || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Aspect Ratio</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.aspect_ratio || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Rim Diameter</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.rim_diameter || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Plant Code</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.plant_code || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Size Code</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.size_code || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Aux Info.</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.aux_info || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Cure Week/Year</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.cure_wkyr || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Speed Rating</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.speed_rating || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Load Range</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.load_range || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Construction</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.construction || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Punctures/Repairs</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.repairs || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Min. Tread Depth (32nds of in.)</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.min_tread_depth || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Max. Tread Depth (32nds of in.)</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.max_tread_depth || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Failure Mode</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.failure_mode || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">DOT Number</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.dot || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginY: "10px" }} />
                        <Grid container item md={12} display="flex" justifyContent="space-between">
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">Failure Factors</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginY: "10px" }} />

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Manufacture Defect</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.mfg_defect ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Design Defect</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.design_defect ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Aging</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.aging ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ marginY: "10px" }} />
                        <Grid container item md={12} display="flex" justifyContent="space-between">
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">TSA+ Alerts</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginY: "10px" }} />

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Defective Tire Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.defective_tire_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Early Warning Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.early_warning_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Early Degradation Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.early_degradation_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Forensic Investigation Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.forensic_investigation_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Reported Tire Failure Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.reported_tire_failure_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Dealer Reported Tire Failure Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.dealer_reported_tire_failure_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Reported Early Warning Alert</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.reported_early_waring_alert ? 'YES' : 'NO'}</Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ marginY: "10px" }} />
                        <Grid container item md={12} display="flex" justifyContent="space-between">
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">Vehicle Information</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginY: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">VIN</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.vin || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">YEAR</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.car_year || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">MAKE</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.car_make || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">MODEL</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.car_model || <Skeleton />}</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ marginY: "10px" }} />
                        <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                            <Grid item md={3}>
                                <Typography variant="body1">Status</Typography>
                            </Grid>
                            <Grid item md={9}>
                                <Typography variant="body1">{privateDBDetails?.status ? 'ACTIVE' : 'INACTIVE'}</Typography>
                            </Grid>
                        </Grid>

                        <CardActions sx={{ padding: "15px" }}>
                            <Button
                                disabled={disableButton}
                                variant="contained"
                                color='primary'
                                type="submit"
                                onClick={() => navi(`/privatedb/edit/${privateDBDetails?.id}`)}
                            >
                                Edit
                            </Button>
                            <Button
                                disabled={disableButton}
                                variant="outlined"
                                type="submit"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </Button>
                            <Typography sx={{ flexGrow: 1 }} />
                            <Button
                                disabled={disableButton}
                                variant="outlined"
                                type="submit"
                                onClick={() => handleDelete()}
                                color={'warning'}
                            >
                                delete
                            </Button>
                        </CardActions>
                    </Container>
                </Card>
            </Container>
        </React.Fragment>
    )


}

export default PrivateDBView;